import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M2.898 9.518a.82.82 0 0 1-.837-.822q0-.35.24-.585a.82.82 0 0 1 .597-.236h3.413q.728 0 1.266.475.537.475.623 1.168zm2.254 9.839q1.449 0 2.463-.996a3.26 3.26 0 0 0 1.015-2.417 3.26 3.26 0 0 0-1.015-2.418q-1.014-.995-2.463-.995t-2.463.995a3.26 3.26 0 0 0-1.015 2.418A3.26 3.26 0 0 0 2.69 18.36q1.014.996 2.463.996m15.22 0q.805 0 1.38-.564a1.83 1.83 0 0 0 .574-1.353 1.83 1.83 0 0 0-.575-1.354 1.9 1.9 0 0 0-1.379-.564q-.805 0-1.38.564a1.83 1.83 0 0 0-.573 1.354q0 .79.574 1.353.574.564 1.38.564M5.15 17.377q-.609 0-1.033-.42a1.38 1.38 0 0 1-.424-1.016q0-.597.427-1.014.426-.416 1.036-.416.609 0 1.033.419t.424 1.016q0 .599-.427 1.014-.426.417-1.036.417m15.76-3.47q.532.105.889.264.356.159.785.522V8.486a1.9 1.9 0 0 0-.593-1.399 1.96 1.96 0 0 0-1.425-.581h-6.388L13.005 5.3l1.562-1.534L13.786 3 9.823 6.89l.838.766 1.562-1.534 1.172 1.15v2.099q0 1.077-.782 1.845a2.6 2.6 0 0 1-1.88.767h-2.4q.481.37.775.738.295.366.61.905h1.015q1.8 0 3.068-1.245t1.269-3.01V8.149h5.495q.15 0 .247.095a.32.32 0 0 1 .097.242zm-4.105 2.858q.135-.538.308-.883.171-.343.536-.76h-7.423q.08.473.08.822 0 .35-.08.821zM20.372 21q-1.51 0-2.57-1.039a3.4 3.4 0 0 1-1.058-2.521q0-1.485 1.058-2.522 1.06-1.038 2.57-1.039 1.512 0 2.57 1.039A3.4 3.4 0 0 1 24 17.44q0 1.483-1.058 2.521-1.059 1.04-2.57 1.039m-15.22 0q-2.137 0-3.645-1.479Q0 18.042 0 15.944t1.507-3.577 3.645-1.48 3.645 1.48 1.507 3.577-1.507 3.577Q7.29 21 5.152 21"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M24 0v24H0V0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
